<template>
  <section class="intro pb-16">
    <article>
      <h1>{{ slogan }}</h1>
      <p>Již více jak 15 let</p>
      <v-btn
        href="/kontakty"
        variant="flat"
        size="large"
      >Kontaktujte nás</v-btn>
    </article>
    <div
      ref="sliderEl"
      class="my-slider"
    >
      <!-- Slide 1 -->
      <div
        class="slide"
        style="background: url('/images/vetrna-elektrarna.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 2 -->
      <div
        class="slide"
        style="background: url('/images/tepelne-cerpadlo.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 3 -->
      <div
        class="slide"
        style="background: url('/images/klimatizace.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 4 -->
      <div
        class="slide"
        style="background: url('/images/zabezpeceni.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 5 -->
      <div
        class="slide"
        style="background: url('/images/termicke-panely.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 6 -->
      <div
        class="slide"
        style="background: url('/images/elektorinstalace.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 7 -->
      <div
        class="slide"
        style="background: url('/images/rekuperace.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 8 -->
      <div
        class="slide"
        style="background: url('/images/fotovoltaicka-elektrarna.avif') center/cover no-repeat"
      >
      </div>

      <!-- Slide 9 -->
      <div
        class="slide"
        style="background: url('/images/podlahove-vytapeni.avif') center/cover no-repeat"
      >
      </div>

    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{ slogan: string }>()

import { ref, onMounted, onBeforeUnmount } from 'vue'
// If your bundler supports it, this import is fine:
import { tns } from 'tiny-slider/src/tiny-slider'
// Otherwise try: import { tns } from 'tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

const sliderEl = ref(null)
let sliderInstance

onMounted(() => {
  sliderInstance = tns({
    container: sliderEl.value,
    items: 1,
    slideBy: 'page',
    controls: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayButtonOutput: false,
    mouseDrag: true,
    gutter: 0,
    speed: 400,
    loop: true,
    touch: true,
  })
})

onBeforeUnmount(() => {
  sliderInstance?.destroy()
})
</script>
